
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { RiRefreshLine } from "react-icons/ri";
import { IoSearchOutline } from "react-icons/io5";
import { RxDownload } from "react-icons/rx";
import ExcelJS from "exceljs";
import YourLogo from "../../Assets/Images/Pro_Logo.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import LeaseApiService from '../../services/apiService';
import WindowedSelect from 'react-windowed-select';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { ClipLoader } from "react-spinners";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment/moment';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { getCompany } from '../../../Redux/selecters';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useClientFeatures } from '../../utils/clientFeatures';
import {
    toUpdatePayload, validateUpdate, MSG_ALREADY_POSTED,
} from './revenuePostingHelpers';

const POSTING_LIST_ROUTE = '/Property/Management/Lease/Revenue/Postings';
const REVENUE_ROUTE = '/Property/Management/Lease/Revenue/Posting';
const toApiDate = (value) => (value ? moment(value).format('YYYY-MM-DD') : '');
const BADGE_STYLE = { display: 'inline-block', padding: '2px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600 };


const LeaseRevenueList = () => {
    const [FilterTab, setFilterTab] = useState(true);
    const [Tab, setTab] = useState(true);
    const [unitList, setUnitList] = useState([])
    const [proprtyList, setProperty] = useState([]);
    const [DebitList, setDebitList] = useState([]);
    const [CreditList, setCreditList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [selectedType, setSelectedType] = useState({ label: 'ALL', value: 'ALL' });
    const [dataList, setDataList] = useState([]);
    const apiService = new LeaseApiService();
    const [loading, setloader] = useState(false);
    const [saveLoader, setloading] = useState(false);
    const [periodFrom, setPeriodFrom] = useState("");
    const [contcextMenu, setContextMenu] = useState();
    const [periodTo, setPeriodTo] = useState("");
    const [postedDate, setpostedDate] = useState("");
    const [searchedPeriod, setSearchedPeriod] = useState({ from: "", to: "" });
    const [isCleared, setIscleared] = useState(false);
    const [unposted, setunposted] = useState(false);
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    const [selectedRows, setSelectedRows] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [activeFY, setActiveFY] = useState(null);
    const [GlModal, setGlModal] = useState(false);
    const [pendingBody, setPendingBody] = useState(null);
    const Company = useSelector(getCompany);
    const [isKanooCompany, setKanooCompany] = useState(false);

    // Jaberi-only edit mode (reached from the postings list with ?postingNo=). Everything below is inert otherwise.
    const { canEditRevenuePostings } = useClientFeatures();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const postingNo = canEditRevenuePostings ? searchParams.get('postingNo') : null;
    const editMode = !!postingNo;
    const [postingHeader, setPostingHeader] = useState(null);
    const [editBusy, setEditBusy] = useState('');     // overlay text; '' = idle
    const [editDialog, setEditDialog] = useState(null); // 'save' | 'delete' | 'empty'
    const [approvedDialog, setApprovedDialog] = useState(false);
    const [forceReadOnly, setForceReadOnly] = useState(false);
    const [postedWarning, setPostedWarning] = useState('');
    const [defaultAccounts, setDefaultAccounts] = useState(null); // debit / credit accounts loaded on page open, restored on Reset
    const readOnly = editMode && (searchParams.get('mode') === 'view' || postingHeader?.canEdit !== true || forceReadOnly);

    const onGridReady = (params) => {
        setGridApi(params.api);
    };
    useEffect(() => {
        fetchDropdownData();
    }, []);
    useEffect(() => {
        checkCompanyName();
    }, [Company]);
    const checkCompanyName = () => {
        const DB = localStorage.getItem('DataBase');
        const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
        const defaultCompany = companies.find((comp) => comp.dataDB === DB);
        const companyName = defaultCompany?.companyName?.toLowerCase() || '';
        const isKanoo = companyName.includes('accountcode') || companyName.includes('kanoo') || companyName.includes('bh');
        setKanooCompany(isKanoo);
    };

    const formatDat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        const today = new Date();

        // First day of current month
        const firstDayCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        // First day of next month
        const firstDayNextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        setPeriodFrom(formatDat(firstDayCurrentMonth));
        setPeriodTo(formatDat(firstDayNextMonth));

        const handleClickOutside = () => setContextMenu(null);

        window.addEventListener("click", handleClickOutside);

        return () => window.removeEventListener("click", handleClickOutside);
    }, []);

    useEffect(() => {
        if (gridApi && !editMode) {
            gridApi.forEachNode((node) => {
                node.setSelected(selectedRows.some(r => r.leaseNo === node.data.leaseNo));
            });
            const timeoutId = setTimeout(() => gridApi.autoSizeAllColumns(), 0);
            return () => clearTimeout(timeoutId);
        }
    }, [dataList]);

    useEffect(() => {
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);

    const [transData, setTransData] = useState({
        debitAcc: [{ label: 'Select Debit Account', value: '' }],
        property: [{ label: 'Select Property', value: '' }],
        CraditAcc: [{ label: 'Select Credit Account', value: '' }],
        uniNo: [{ label: 'Select Unit No', value: '' }],
        Narration: ""
    });
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRPSerPropertyName,LRPDebitAccount,LRPCreditAccount,LRPSerTypes');
            const res = await apiService.getApiParamater('GET_REVENUE_MULTI', `?${params.toString()}`);
            setProperty(res?.data?.dropdowns?.LRPSerPropertyName)
            setDebitList(res?.data?.dropdowns?.LRPDebitAccount)
            const creditAccounts = res?.data?.dropdowns?.LRPCreditAccount;
            setCreditList(creditAccounts)
            setTypeList(res?.data?.dropdowns?.LRPSerTypes)
            const cust1params = new URLSearchParams();
            cust1params.append('Action', 'GetDebitAccountForPosting');
            const cust1res = await apiService.getApiParamater('GET_REVENUE_COMMON', `?${cust1params.toString()}`);
            const editedRow = res?.data?.dropdowns?.LRPDebitAccount?.find(row => row.value === cust1res.data.result.data.Debit);
            const defaultCredit = creditAccounts?.find(row => row?.text?.toLowerCase()?.includes('rent revenue'));
            if (!editMode) {
                const accounts = {
                    debitAcc: { label: editedRow?.text || "", value: editedRow?.value || "" },
                    CraditAcc: defaultCredit ? { label: defaultCredit.text, value: defaultCredit.value } : transData.CraditAcc,
                };
                setDefaultAccounts(accounts);
                setTransData({ ...transData, ...accounts });
            }

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handlePropertyChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append('DropdownFor', 'LRPUnitNosByProperty');
        params.append('CascadValue', selectedOption?.value);
        const res = await apiService.getApiParamater('GET_REVENUE_CASCAD', `?${params.toString()}`);
        setUnitList(res?.data?.items);
        setTransData({
            ...transData,
            property: selectedOption,
            uniNo: [{ label: '', value: '' }]
        });
    }
    const handleUitNo = (selectedOption) => {
        setTransData({ ...transData, uniNo: selectedOption });
    }
    const handleDebit = (selectedOption) => {
        setTransData({ ...transData, debitAcc: selectedOption });
    }
    const handleCredit = (selectedOption) => {
        setTransData({ ...transData, CraditAcc: selectedOption });
    }
    const handleClearFilters = () => {
        setTransData({
            // the debit / credit accounts go back to the ones loaded on page open instead of being emptied
            debitAcc: defaultAccounts?.debitAcc || [{ label: 'Select Debit Account', value: '' }],
            property: [{ label: 'Select Property', value: '' }],
            CraditAcc: defaultAccounts?.CraditAcc || [{ label: 'Select Credit Account', value: '' }],
            uniNo: [{ label: 'Select Unit No', value: '' }],
        });
        setUnitList([])
        setPostedWarning('')
        setSelectedRows([])
        setDataList([])
        setSelectedType({ label: 'ALL', value: 'ALL' })
    }
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handlePeriodFromChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodFrom(formattedDate);
    }
    const handlePeriodToChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodTo(formattedDate);
    }
    const handlePostingDate = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setpostedDate(formattedDate);
    }
    const handleCleared = () => {
        setIscleared(!isCleared);
    };
    const handleUnposted = () => {
        setunposted(!unposted);
    };
    const handleTypeChange = (selectedOption) => {
        setSelectedType(selectedOption);
    };
    const SearchItems = async () => {
        try {
            setloader(true);
            const params = new URLSearchParams();
            params.append('PropertyNo', transData?.property?.value || 'All');
            params.append('UnitNo', transData?.uniNo?.label || 'All');
            params.append('FromDate', periodFrom);
            params.append('ToDate', periodTo);
            params.append('PMUnits', isCleared);
            params.append('UnPosted', unposted);
            params.append('Type', selectedType?.label || 'ALL');
            setPostedWarning('');
            const res = await apiService.getApiParamater('GET_REVENUE_LIST', `?${params.toString()}`);
            if (canEditRevenuePostings && res?.data?.message === MSG_ALREADY_POSTED) setPostedWarning(res.data.message);
            setDataList(res?.data?.result || []);
            setSearchedPeriod({ from: periodFrom, to: periodTo });
            setloader(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setloader(false);
        }
    }
    const handlefieldChange = (e) => {
        setTransData({ ...transData, [e.target.name]: e.target.value });
    };
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const decimalFormatter = (params) => {
        const val = parseFloat(params?.value);
        return isNaN(val) ? '' : val.toFixed(3);
    };
    const columnDefs = [
        {
            checkboxSelection: true,
            headerCheckboxSelection: !readOnly,
            headerName: '',
            width: 50,
            pinned: 'left',
            ...(readOnly ? { cellStyle: { pointerEvents: 'none', opacity: 0.6 } } : {}),
        },
        // Jaberi has no revenue types, so the column is hidden for it
        { headerName: 'Type', field: 'type', filter: true, suppressMovable: false, pinned: 'left', hide: canEditRevenuePostings },
        { headerName: 'Lease No', field: 'leaseNo', filter: true, suppressMovable: false, pinned: 'left' },
        { headerName: 'Property Name', field: 'propertyName', filter: true, suppressMovable: false },
        { headerName: 'Unit No', field: 'unitNo', filter: true, suppressMovable: false },
        { headerName: 'Credit Account', field: 'crAcCode', filter: true, suppressMovable: false },
        { headerName: 'Debit Account', field: 'drAcCode', filter: true, suppressMovable: false },
        {
            headerName: 'Posting Amount', field: 'postingAmount', filter: true, suppressMovable: false, valueFormatter: decimalFormatter,
            // Jaberi only: the amount can be adjusted (3 decimals) before posting / saving
            ...(canEditRevenuePostings && !readOnly ? {
                editable: true,
                valueParser: (p) => {
                    const v = parseFloat(String(p.newValue ?? '').replace(/,/g, ''));
                    return Number.isNaN(v) ? p.oldValue : Math.round(v * 1000) / 1000;
                },
                cellStyle: { backgroundColor: '#FFFBE6' },
            } : {}),
        },
        { headerName: 'Narration', field: 'narration', filter: true, suppressMovable: false },
        {
            headerName: 'Lease From', field: 'leaseDate',
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: false,
        },
        {
            headerName: 'Lease To', field: 'leaseExpiry',
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: false,
        },
        { headerName: 'Total Lease', field: 'totalLeaseDays', suppressMovable: false },
        { headerName: 'Contract Value', field: 'contractValue', suppressMovable: false, valueFormatter: decimalFormatter },
        { headerName: 'Rent Per Day', field: 'rentPerDay', filter: true, suppressMovable: false, valueFormatter: decimalFormatter },
        { headerName: 'Days to Calculate', field: 'daysToCalculate', filter: true, suppressMovable: false },
        { headerName: 'Posted Amount', field: 'postedAmount', filter: true, suppressMovable: false, valueFormatter: decimalFormatter },
        { headerName: 'Balance', field: 'balance', filter: true, suppressMovable: false, valueFormatter: decimalFormatter },
    ]
    const decimalFields = ['postedAmount', 'balance', 'contractValue', 'rentPerDay', 'postingAmount'];
    const fetchLogoImage = async (url) => {
        const res = await fetch(url);
        const contentType = res.headers.get('content-type') || '';
        const blob = await res.blob();
        const buffer = await blob.arrayBuffer();
        let extension = 'png';
        if (contentType.includes('jpeg') || contentType.includes('jpg')) extension = 'jpeg';
        else if (contentType.includes('gif')) extension = 'gif';
        return { buffer, extension };
    };
    const exportExcel = async () => {
        if (!dataList?.length) {
            toast.warning('No data to export');
            return;
        }
        const exportColumns = columnDefs
            .filter(col => col.field && col.field !== 'isSelected' && !col.hide)
            .map(col => ({ header: col.headerName, dataKey: col.field }));

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Lease Revenue Posting');
        worksheet.views = [{ showGridLines: false }];

        // Same logo source used by the app sidebar (PMSideBar.js)
        const logoUrl = Company?.selectedCompany?.logo || YourLogo;
        try {
            const { buffer, extension } = await fetchLogoImage(logoUrl);
            const imageId = workbook.addImage({ buffer, extension });
            worksheet.addImage(imageId, {
                tl: { col: 0, row: 0 },
                ext: { width: 150, height: 60 },
            });
        } catch (error) {
            console.error('Error loading logo for export:', error);
        }

        const LOGO_ROWS = 4;
        for (let i = 0; i < LOGO_ROWS; i++) worksheet.addRow([]);

        const titleRow = worksheet.addRow(['Lease Revenue Posting Report']);
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, exportColumns.length);
        titleRow.getCell(1).font = { bold: true, size: 14 };
        titleRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'left' };

        const thinBorder = {
            top: { style: 'thin', color: { argb: 'FFD9D9D9' } },
            left: { style: 'thin', color: { argb: 'FFD9D9D9' } },
            bottom: { style: 'thin', color: { argb: 'FFD9D9D9' } },
            right: { style: 'thin', color: { argb: 'FFD9D9D9' } },
        };

        const headerRow = worksheet.addRow(exportColumns.map(col => col.header));
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF6E5199' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
            cell.border = thinBorder;
        });

        dataList.forEach((item) => {
            const rowValues = exportColumns.map((col) => {
                let value = item?.[col.dataKey];
                if (col.dataKey === 'leaseDate' || col.dataKey === 'leaseExpiry') {
                    value = value ? moment(value).format('DD-MMM-YYYY') : '';
                } else if (decimalFields.includes(col.dataKey)) {
                    value = value === null || value === undefined || value === '' ? null : Number(value);
                }
                return value ?? '';
            });
            const row = worksheet.addRow(rowValues);
            row.eachCell({ includeEmpty: true }, (cell) => {
                cell.border = thinBorder;
                if (Number(item?.isPosted) === 1 || item?.isPosted === true) {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE8DEC4' } };
                }
            });
            decimalFields.forEach((field) => {
                const colIndex = exportColumns.findIndex((c) => c.dataKey === field) + 1;
                if (colIndex > 0) {
                    row.getCell(colIndex).numFmt = '0.000';
                }
            });
        });

        // Auto width columns based on header/content length
        exportColumns.forEach((col, i) => {
            const column = worksheet.getColumn(i + 1);
            let maxLen = col.header.length;
            column.eachCell({ includeEmpty: false }, (cell) => {
                const len = cell.value === null || cell.value === undefined ? 0 : String(cell.value).length;
                if (len > maxLen) maxLen = len;
            });
            column.width = maxLen + 2;
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Lease Revenue Posting.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };
    const onCloseModal = () => {
        setGlModal(false);
        setPendingBody(null);
    };
    const handlePostAnyway = async () => {
        setGlModal(false);
        if (pendingBody) {
            await postRevenue(pendingBody);
            setPendingBody(null);
        }
    };
    const handleSave = async () => {
        try {
            setloading(true);
            if (selectedRows.length === 0) {
                toast.warning(`Please Select Lease from the Posting Grid`);
                setloading(false);
                return;
            }
            if (!postedDate) {
                toast.warning(`Please Select Posting Date`);
                setloading(false);
                return;
            }
            // for (const item of selectedRows) {
            //     if (item?.crAcCode === "0" || "" || item?.crAcName === "0" || "") {
            //         toast.warning(`Please add credit acc to ${item?.propertyName}`)
            //         setloading(false);
            //         return
            //     } else if (item?.drAcCode === "0" || "" || item?.drAcName === "0" || "") {
            //         toast.warning(`Please add debit acc to ${item?.leaseNo}`)
            //         setloading(false);
            //         return
            //     }
            // }

            // Jaberi: a row whose credit account is 0 posts to the Credit Account selected above, so one must be chosen
            const isNoCredit = (code) => !code || String(code).trim() === "0";
            const ddlCredit = transData?.CraditAcc?.value;
            const jaberiCreditFromDdl = canEditRevenuePostings && !!ddlCredit && String(ddlCredit).trim() !== "0";
            if (canEditRevenuePostings && !jaberiCreditFromDdl && selectedRows.some(item => isNoCredit(item?.crAcCode))) {
                toast.warning(`Select Credit Account`);
                setloading(false);
                return;
            }
            const hasInvalidCredit = !jaberiCreditFromDdl && selectedRows.some(
                item => item?.crAcCode === "0"
            );


            const _LeaseRevenuGrid = selectedRows?.map(item => {
                return {
                    isSelected: true,
                    leaseNo: item?.leaseNo,
                    propertyNo: item?.propertyNo,
                    propertyName: item?.propertyName,
                    unitNo: item?.unitNo,
                    unitRefNo: item?.unitRefNo,
                    narration: item?.narration,
                    // leaseDate: item?.leaseDate,
                    // leaseExpiry: item?.leaseExpiry,
                    // backend maps LeaseDate/LeaseExpiry to @Period_From/@Period_To, so send the search period
                    leaseDate: searchedPeriod.from || periodFrom,
                    leaseExpiry: searchedPeriod.to || periodTo,
                    totalLeaseDays: item?.totalLeaseDays,
                    contractValue: item?.contractValue,
                    vat: item?.vat,
                    rent: item?.rent,
                    balance: item?.balance,
                    rentPerDay: item?.rentPerDay,
                    daysToCalculate: item?.daysToCalculate,
                    postingAmount: item?.postingAmount,
                    recordId: item?.recordId,
                    postedAmount: item?.postedAmount,
                    crAcCode: jaberiCreditFromDdl && isNoCredit(item?.crAcCode) ? ddlCredit : item?.crAcCode,
                    // crAcCode: item?.crAcCode === "0" ? transData?.CraditAcc?.value : item?.crAcCode,
                    crAcName: jaberiCreditFromDdl && isNoCredit(item?.crAcCode) ? transData?.CraditAcc?.label : item?.crAcName,
                    // crAcName: item?.crAcName === "0" ? transData?.CraditAcc?.label : item?.crAcName,
                    drAcCode: item?.drAcCode,
                    // drAcCode: item?.drAcCode === "0" ? transData?.debitAcc?.value : item?.drAcCode,
                    drAcName: item?.drAcName,
                    // drAcName: item?.drAcName === "0" ? transData?.debitAcc?.label : item?.drAcName,
                    fYear: activeFY?.value?.id,
                    isPosted: item?.isPosted
                }
            });

            const body = {
                leaseRevenueMain: {
                    propertyNo: transData?.property?.value || "",
                    unitNo: transData?.uniNo.label || "",
                    periodFrom: searchedPeriod.from || periodFrom,
                    periodTo: searchedPeriod.to || periodTo,
                    pmUnits: isCleared,
                    unPostedUnits: unposted,
                    postingDate: postedDate,
                    debitAccount: transData?.debitAcc?.value,
                    creditAccount: transData?.CraditAcc?.value,
                    refNo: "0",
                    narration: transData.Narration || "",
                    _LeaseRevenuGrid: _LeaseRevenuGrid,
                },
            };
            // 👉 C# equivalent condition
            if (hasInvalidCredit) {
                setPendingBody(body);   // store request
                setGlModal(true);       // show popup
                setloading(false);
                return;
            }

            // Normal post
            await postRevenue(body);


        } catch (error) {
            setloading(false);

            console.error("Error Save Data", error);
        }
    }
    const postRevenue = async (body) => {
        try {
            setloading(true);
            const postRes = await apiService.post("POST_REVENUE", body);
            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                toast.success(`Posted  successfully`);
                setSelectedRows([]);
                setDataList([]);
                setloading(false);
            } else {
                setloading(false);
            }
        } catch (error) {
            console.error("Post Error", error);
        } finally {
            setloading(false);
        }
    };

    const loadPosting = async () => {
        setEditBusy('Loading posting…');
        try {
            const res = await apiService.getLeaseRevenuePostingByNo(postingNo);
            // 204 = feature off for this client: fall back to the normal screen, silently
            if (res?.status === 204) {
                navigate(REVENUE_ROUTE, { replace: true });
                return;
            }
            const { header, lines } = res?.data?.result || {};
            if (!header) {
                toast.error('Posting not found.');
                navigate(POSTING_LIST_ROUTE, { replace: true });
                return;
            }
            setPostingHeader(header);
            setPeriodFrom(toApiDate(header.periodFrom));
            setPeriodTo(toApiDate(header.periodTo));
            setpostedDate(toApiDate(header.postingDate));
            setTransData((prev) => ({
                ...prev,
                debitAcc: { label: header.debitAcName, value: header.debitAcCode },
                CraditAcc: { label: header.creditAcName, value: header.creditAcCode },
                Narration: header.commonNarration || '',
            }));
            const rows = Array.isArray(lines) ? lines : [];
            setDataList(rows);
            setSelectedRows(rows.filter((l) => l.isSelected));
        } catch (error) {
            if (error?.response?.status === 404) {
                toast.error('Posting not found.');
                navigate(POSTING_LIST_ROUTE, { replace: true });
            } else {
                toast.error(error?.response?.data?.message || 'Unable to load the posting.');
            }
        } finally {
            setEditBusy('');
        }
    };
    useEffect(() => {
        if (editMode) loadPosting();
    }, [postingNo, canEditRevenuePostings]);

    // Tick the lines that are part of the posting (by recordId: a lease can appear on several lines)
    useEffect(() => {
        if (!gridApi || !editMode) return;
        gridApi.forEachNode((node) => {
            node.setSelected(!!node.data?.isSelected);
        });
        const timeoutId = setTimeout(() => gridApi.autoSizeAllColumns(), 0);
        return () => clearTimeout(timeoutId);
    }, [dataList, gridApi, editMode]);

    // Every line goes back to the server, ticked or not: an unticked line with a recordId means "remove it".
    const buildEditLines = () => dataList.map((l) => ({
        ...l,
        isSelected: selectedRows.includes(l),
        fYear: l.fYear ?? activeFY?.value?.id,
    }));
    const handleEditSave = () => {
        const check = validateUpdate(postedDate, buildEditLines());
        if (check.emptyPosting) {
            setEditDialog('empty');
        } else if (!check.valid) {
            toast.warning(check.message);
        } else {
            setEditDialog('save');
        }
    };
    const handleEditFailure = (error, fallback) => {
        if (error?.response?.status === 409) {
            setApprovedDialog(true);
        } else {
            toast.error(error?.response?.data?.message || fallback);
        }
    };
    const confirmEditSave = async () => {
        setEditDialog(null);
        setEditBusy('Saving, please wait…');
        try {
            const body = toUpdatePayload({
                periodFrom: periodFrom,
                periodTo: periodTo,
                postingDate: postedDate,
                debitAccount: transData?.debitAcc?.value,
                creditAccount: transData?.CraditAcc?.value,
                narration: transData?.Narration || '',
            }, buildEditLines());
            const res = await apiService.updateLeaseRevenuePosting(postingNo, body);
            if (res?.status === 204) return;
            if (res?.data?.isSuccessful === false) {
                toast.error(res?.data?.message || 'Unable to save the posting.');
                return;
            }
            toast.success(res?.data?.message || 'Posting updated successfully.');
            navigate(POSTING_LIST_ROUTE);
        } catch (error) {
            handleEditFailure(error, 'Unable to save the posting.');
        } finally {
            setEditBusy('');
        }
    };
    const confirmEditDelete = async () => {
        setEditDialog(null);
        setEditBusy('Deleting, please wait…');
        try {
            const res = await apiService.deleteLeaseRevenuePosting(postingNo);
            if (res?.status === 204) return;
            toast.success(res?.data?.message || 'Posting deleted successfully.');
            navigate(POSTING_LIST_ROUTE);
        } catch (error) {
            handleEditFailure(error, 'Unable to delete the posting.');
        } finally {
            setEditBusy('');
        }
    };
    // 409: re-read the posting and lock the screen
    const handleReloadAfterApproval = async () => {
        setApprovedDialog(false);
        setForceReadOnly(true);
        await loadPosting();
    };

    return (
        <div className='p-3'>
            {editMode && (
                <div className="cost-center-section mb-3">
                    <div className="border-box2 p-3">
                        <div className="d-flex align-items-center gap-4 flex-wrap">
                            <div><span className="text-muted">Posting No</span> <b>{postingHeader?.postingNo ?? postingNo}</b></div>
                            <div><span className="text-muted">Voucher No</span> <b>{postingHeader?.voucherNo}</b></div>
                            <div><span className="text-muted">Financial Year</span> <b>{postingHeader?.financialYear}</b></div>
                            <div><span className="text-muted">Period</span> <b>{periodFrom ? moment(periodFrom).format('DD-MMM-YYYY') : ''} – {periodTo ? moment(periodTo).format('DD-MMM-YYYY') : ''}</b></div>
                            {postingHeader && (
                                <span style={postingHeader.isApproved
                                    ? { ...BADGE_STYLE, background: '#DCF5E4', color: '#1C7C3C' }
                                    : { ...BADGE_STYLE, background: '#FFF1D6', color: '#9A6700' }}>
                                    {postingHeader.isApproved ? 'Approved' : 'Pending'}
                                </span>
                            )}
                            <div className="d-flex gap-3 ms-auto">
                                {!readOnly && (
                                    <>
                                        <div className="mainbtn flex-end gap-2" role="button" tabIndex={0} onClick={handleEditSave}
                                            onKeyDown={(e) => { if (e.key === 'Enter') handleEditSave(); }}>
                                            <FaSave color="#fff" className="center mt-1 mx-2" />
                                            <div className="center">Save</div>
                                        </div>
                                        <div className="mainbtnRed flex-end gap-2" role="button" tabIndex={0} onClick={() => setEditDialog('delete')}
                                            onKeyDown={(e) => { if (e.key === 'Enter') setEditDialog('delete'); }}>
                                            <div className="center">Delete</div>
                                        </div>
                                    </>
                                )}
                                <div className="mainbtnGry flex-end gap-2" role="button" tabIndex={0} onClick={() => navigate(POSTING_LIST_ROUTE)}
                                    onKeyDown={(e) => { if (e.key === 'Enter') navigate(POSTING_LIST_ROUTE); }}>
                                    <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
                                    <div className="center">{readOnly ? 'Back' : 'Cancel'}</div>
                                </div>
                            </div>
                        </div>
                        {readOnly && postingHeader && postingHeader.canEdit !== true && (
                            <div className="alert alert-warning mt-3 mb-0" role="alert">
                                {postingHeader?.editBlockReason || 'This posting cannot be changed.'}
                            </div>
                        )}
                    </div>
                </div>
            )}
            {!editMode && (
            <div className="cost-center-section mb-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>Search Details</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(220px, 1fr))', gap: '15px' }}>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Property</label>
                                <WindowedSelect
                                    className="w-75 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={transData.property}
                                    options={proprtyList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> Unit No</label>
                                <WindowedSelect
                                    className="w-75 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={transData.uniNo}
                                    options={unitList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                />
                            </div>
                            <div className='d-flex'>
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> From Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={periodFrom}
                                    onChange={(date) => handlePeriodFromChange({ name: 'leaseDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className='d-flex'>
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> To Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={periodTo}
                                    onChange={(date) => handlePeriodToChange({ name: 'toDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex align-items-center gap-3" style={{ gridColumn: '1 / -1', flexWrap: 'wrap' }}>
                                <div className="d-flex gap-2 center" style={{ minWidth: '260px' }}>
                                    <input
                                        style={{ width: "20px", height: "20px" }}
                                        type="checkbox"
                                        className="form-check-input center"
                                        checked={isCleared}
                                        onChange={handleCleared}
                                    />
                                    <label htmlFor="validationCustom01" className="form-label pt-2 start"> Include PM Units</label>
                                </div>
                                <div className="d-flex gap-2 center" style={{ minWidth: '260px' }}>
                                    <input
                                        style={{ width: "20px", height: "20px" }}
                                        type="checkbox"
                                        className="form-check-input center"
                                        checked={unposted}
                                        onChange={handleUnposted}
                                    />
                                    <label htmlFor="validationCustom01" className="form-label pt-2 start">Show Unposted only</label>
                                </div>
                                {!canEditRevenuePostings && (
                                    <div className="d-flex" style={{ minWidth: '350px' }}>
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Type</label>
                                        <WindowedSelect
                                            className="w-75 p-0"
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            menuPlacement="auto"
                                            menuShouldScrollIntoView={false}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                    color: '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000',
                                                    },
                                                }),
                                            }}
                                            value={selectedType}
                                            options={[{ label: 'ALL', value: 'ALL' }, ...(typeList?.map((cost) => ({ value: cost?.value, label: cost?.text })) || [])]}
                                            onChange={(selectedOption) => handleTypeChange(selectedOption)}
                                        />
                                    </div>
                                )}
                                <div className="d-flex gap-3" style={{ marginLeft: 'auto', flexShrink: 0 }}>
                                    {loading === true ? (
                                        <div className="mainbtnGry w-50">
                                            <ClipLoader color="#ffffff" className="mt-1" size={25} />
                                        </div>
                                    ) : (
                                        <div className="mainbtnGry flex-end gap-2" onClick={SearchItems}>
                                            <IoSearchOutline color="#fff" className="center mt-1 mx-2" />
                                            <div className="center">Search</div>
                                        </div>
                                    )}
                                    <div className="mainbtnRed flex-end gap-2" onClick={handleClearFilters} >
                                        <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Reset</div>
                                    </div>
                                    {saveLoader === true ? (
                                        <div className="mainbtn w-50">
                                            <ClipLoader color="#ffffff" className="mt-1" size={25} />
                                        </div>
                                    ) : (
                                        <div className="mainbtn flex-end gap-2" onClick={handleSave}>
                                            <FaSave color="#fff" className="center mt-1 mx-2" />
                                            <div className="center">Save</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setTab(!Tab)}>
                    <div className='h6 pt-1'>Transection Details</div>
                </div>
                <div className={`slide-content ${Tab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${Tab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '10px' }}>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Debit Account</label>
                                <WindowedSelect
                                    className="w-75 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    isDisabled
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={transData.debitAcc}
                                    options={DebitList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handleDebit(selectedOption)}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Credit Account</label>
                                <WindowedSelect
                                    className="w-75 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    isDisabled={isKanooCompany || readOnly}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={transData.CraditAcc}
                                    options={CreditList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handleCredit(selectedOption)}
                                />
                            </div>
                            <div className='d-flex'>
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> Posting Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={postedDate}
                                    disabled={readOnly}
                                    onChange={(date) => handlePostingDate({ name: 'postedDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex" style={{ gridColumn: 'span 2' }}>
                                <label className="form-label pt-1 start">Narration</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-100"
                                    name="Narration"
                                    value={transData?.Narration}
                                    disabled={readOnly}
                                    onChange={handlefieldChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-end mb-2'>
                <div className="mainbtnGry flex-end gap-2" onClick={exportExcel}>
                    <RxDownload color="#fff" className="center mt-1 mx-2" />
                    <div className="center">Export to Excel</div>
                </div>
            </div>
            {postedWarning && (
                <div className="alert alert-warning" role="alert">{postedWarning}</div>
            )}
            <div className='gridshad mt-1'>
                <div className='table-container'>
                    <div className="ag-theme-quartz" style={{ height: 650 }}>
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (Number(params.data?.isPosted) === 1 || params.data?.isPosted === true) {
                                    return { backgroundColor: '#E8DEC4', border: 'none' };
                                }
                                return { background: params.node.rowIndex % 2 === 0 ? '#F0EDF5' : '#fff' };
                            }}
                            rowData={dataList}
                            columnDefs={columnDefs}
                            suppressRowClickSelection={true}
                            rowSelection="multiple"
                            rowMultiSelectWithClick={true}
                            // getRowId={(params) => params.data.leaseNo}
                            onGridReady={onGridReady}
                            onSelectionChanged={(params) => {
                                const selected = params.api.getSelectedRows();
                                setSelectedRows(selected);
                            }}
                        />
                    </div>
                </div>
            </div>
            {editBusy && (
                <div role="status" style={{ position: 'fixed', inset: 0, background: 'rgba(255,255,255,0.75)', zIndex: 2000, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
                    <ClipLoader color="#6E5199" size={40} />
                    <div className="h6">{editBusy}</div>
                </div>
            )}
            <Modal size="md" show={editDialog === 'save' || editDialog === 'delete' || editDialog === 'empty'} onHide={() => setEditDialog(null)} backdrop="static">
                <Modal.Header closeButton><Modal.Title className="center">Confirmation</Modal.Title></Modal.Header>
                <Modal.Body>
                    {editDialog === 'save' && `Save changes to posting ${postingNo}?`}
                    {editDialog === 'delete' && `Delete posting ${postingNo}? This removes its voucher as well.`}
                    {editDialog === 'empty' && 'This removes every line from the posting. Delete it instead?'}
                </Modal.Body>
                <Modal.Footer className="end p-3">
                    <button className="mainbtnGry" onClick={() => setEditDialog(null)}>Cancel</button>
                    {editDialog === 'save' && <button className="mainbtn" onClick={confirmEditSave}>Save</button>}
                    {(editDialog === 'delete' || editDialog === 'empty') && <button className="mainbtnRed" onClick={confirmEditDelete}>Delete</button>}
                </Modal.Footer>
            </Modal>
            <Modal size="md" show={approvedDialog} backdrop="static" keyboard={false}>
                <Modal.Header><Modal.Title className="center">Posting approved</Modal.Title></Modal.Header>
                <Modal.Body>This posting has been approved and can no longer be changed.</Modal.Body>
                <Modal.Footer className="end p-3">
                    <button className="mainbtn" onClick={handleReloadAfterApproval}>Reload</button>
                </Modal.Footer>
            </Modal>
            <Modal size="sm"
                show={GlModal}
                onHide={onCloseModal}
                contentLabel="Email Modal"
                style={customStyles}
                closeButton
            >
                <Modal.Header closeButton>
                    <Modal.Title className="center">
                        Invalid Account Code
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        Invalid credit accounts found. Those units revenue will not post.
                    </div>
                </Modal.Body>

                <Modal.Footer className="end p-3">
                    <button className="mainbtn" onClick={onCloseModal}>
                        Cancel
                    </button>
                    <button className="mainbtn" onClick={handlePostAnyway}>
                        Post
                    </button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default LeaseRevenueList;
const customStyles = {
    content: {
        width: '30%', // Set the desired width
        height: '75%', // Set the desired 
        top: '50%', // Center vertically
        left: '50%', // Center horizontally
        right: '50%', // Center horizontally
        transform: 'translate(-50%, -50%)', // Center both vertically and horizontally
    },
};
